/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Identifies if the service contact is a primary contact or not or a service team
 * @export
 * @enum {string}
 */
export enum ServiceContactType {
    Unknown = 'unknown',
    Primary = 'primary',
    ServiceTeam = 'serviceTeam'
}


export function ServiceContactTypeFromJSON(json: any): ServiceContactType {
    return ServiceContactTypeFromJSONTyped(json, false);
}

export function ServiceContactTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceContactType {
    return json as ServiceContactType;
}

export function ServiceContactTypeToJSON(value?: ServiceContactType | null): any {
    return value as any;
}

